import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Header from "../Units/Header";
import '../../assets/stylesheets/ProfileSlide/LinkEmail.scss';
import * as EmailValidator from 'email-validator';
import { sendVerificationCode, codeVerifySuccess } from '../../store/actionCreators/account';
import { getSentCode } from '../../store/selectors';

const LinkEmail = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { verified, verificationCode: sentCode } = useSelector(getSentCode);
  const [email, setEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [codeIsInvalid, setCodeIsInvalid] = useState(false);
  const [emailIsValid, setEmailIsValid] = useState('');

  const onChangeEmail = useCallback((e) => {
    const email = e.target.value;
    setEmail(email);
  }, [setEmail]);

  const onChangeVerificationCode = (e) => {
    const code = e.target.value;
    setVerificationCode(code);
  };

  const sendToEmail = () => {
    emailIsValid === 'valid' &&
      dispatch(sendVerificationCode({ email: email }))
  };

  const validateEmail = () => {
    if (EmailValidator.validate(email))
      setEmailIsValid('valid')
    else
      setEmailIsValid('invalid')
  }

  useEffect(() => {
    (verificationCode.length === 7) &&
      sendToEmail();
  }, [verificationCode]);


  useEffect(() => {
    ((verificationCode.length > 0) && (verificationCode === sentCode)) ?
      dispatch(codeVerifySuccess({})) : //verification should be compared in saga & here should be request
      setCodeIsInvalid(true);
  }, [verificationCode]);

  useEffect(() => {
    !!verified && setTimeout(() => history.push(`/settings`), 2500);
  }, [verified])

  return (
    <div className={`linkYourEmail`}>
      {!!verified ? <span className="successMessage">{t('linkEmail.alreadyLinked')}</span> :
        <React.Fragment>
          <Header title='linkEmailTitle' backTo={'/settings'} ></Header>
          <div className={`section`}>
            {(sentCode.length > 1) ?
              <div className={`verificationForm`}>
                {t('linkEmail.verificationCode')}
                <div className={`${emailIsValid} emailContainer`}>
                  <input value={verificationCode || ''} onChange={(e) => onChangeVerificationCode(e)} />
                  {!codeIsInvalid && <span></span>}
                </div>
                {(!!codeIsInvalid && (sentCode.lenght > 0)) && <div className={`errorMessage`}>{t('linkEmail.unverifiedCode')}</div>}
              </div> :
              <React.Fragment>
                <div className={`writeEmail`}>{t('linkEmail.writeYourEmail')}</div>
                <div className={`emailAddress`}>
                  {t('linkEmail.emailAddress')}
                  <div className={`${emailIsValid} emailContainer`}>
                    <input value={email || ''} onChange={(e) => onChangeEmail(e)} onBlur={() => validateEmail()} />
                    <span></span>
                  </div>
                  {emailIsValid === 'invalid' && email && <div className={`errorMessage`}>Invalid email address</div>}
                  <button className={`tertiary`}>{t('linkEmail.resendCode')}</button>
                </div>
              </React.Fragment>
            }
          </div>
          <div className={`checkEmail`}>{t('linkEmail.checkYourMail')}</div>
          <div className={`dialogConfirmBox`}>
            {(sentCode.length > 1) ?
              <button className="primary" disabled={!verificationCode} onClick={() => sendToEmail()}>{t('button.linkYourEmail')}</button>
              :
              <button className="primary" disabled={!email || emailIsValid !== 'valid'} onClick={() => sendToEmail()}>{t('button.send')}</button>
            }
          </div>
        </React.Fragment>
      }
    </div>
  )
};

export default LinkEmail;
